import RSVP from 'rsvp';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore from '../app/store/configureStore';
import { getCurrentToken } from '../app/services';
import { userGetSession } from '../app/shared/actionCreators';
import 'react-select/dist/react-select.css';
import '../app/shared/styles/custom-react-select.css';
import '../app/shared/styles/signature.css';

global.Promise = RSVP.Promise;
require('isomorphic-fetch');

const store = configureStore({ history: browserHistory });
const history = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById('react-entry');

if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: window.SPOT.env,
    release: window.SPOT.version,
    ignoreErrors: ['Unprocessable Entity', 'CUSTOM', 'Token not refreshed'],
    normalizeDepth: 10, // Or however deep you want your state context to be.
  });
  const sentryOnError = (error) => {
    if (error.payload) {
      Sentry.captureException(error.payload, {
        tags: { action: error.type },
        extra: { ...error.payload },
      });
    } else {
      Sentry.captureException(error);
    }
  };
  window.onunhandledrejection = e => sentryOnError(e.reason);
  RSVP.on('error', sentryOnError);
}

if (getCurrentToken()) {
  store.dispatch(userGetSession());
}

let render = () => {
  const App = require('../app/app.jsx').default; // eslint-disable-line global-require

  ReactDOM.render(
    <Provider store={store}>
      <App history={history} />
    </Provider>,
    rootElement,
  );
};

if (module.hot) {
  // Support hot reloading of components
  // and display an overlay for runtime errors
  const renderApp = render;
  const renderError = (error) => {
    const RedBox = require('redbox-react'); // eslint-disable-line global-require

    console.error(error); // eslint-disable-line no-console
    ReactDOM.render(
      <RedBox error={error} />,
      rootElement,
    );
  };

  render = () => {
    try {
      renderApp();
    } catch (error) {
      renderError(error);
    }
  };

  module.hot.accept('../app/app.jsx', () => {
    setTimeout(render);
  });
}

render();



// WEBPACK FOOTER //
// ./client/packs/client.jsx